import React from 'react';
import {Outlet} from "react-router-dom";
import {AuthService} from "../../service/AuthService";
import {Forbidden} from "../../components/Forbidden";

export const Participant = () => {
  return (
    <>
      { !AuthService.hasRole('ROLE_CALENDRIER') && (
        <Forbidden module="race"/>
      )}
      { AuthService.hasRole('ROLE_CALENDRIER') && (
        <Outlet/>
      )}
    </>
  );
}
